import ko from '@tko/build.knockout';
import $ from 'jquery';

    function LineChartFormatterCommon(params) {

        var self = this;

        self.linechartcolorlist = [ "#3498db", "#34495e", "#16a085", "#9b59b6", "#e74c3c", "#f1c40f"];

    }

    LineChartFormatterCommon.prototype.GenerateTimeline = function(mins) {
        var list = [];

        for (var min = mins; min > 0; min--) {

            list.push("-" + min + " mins");

            list.push("-" + ((min * 60) - 15) + " s");

            list.push("-" + ((min * 60) - 30) + " s");

            list.push("-" + ((min * 60) - 45) + " s");
        }

        list.push("Now");

        return list;
    }

    LineChartFormatterCommon.prototype.getLineColors = function(systems, lines) {
        var self = this;
        var list = [];

        for (var i = 0; i < lines.length; i++) {

            var item = lines[i];

            var index = $.inArray(item, systems);

            if (index > -1) {
                list.push(self.linechartcolorlist[index]);
            }
        }

        return list;

    }

    LineChartFormatterCommon.prototype.getLegendColors = function (systems, lines) {
        var self = this;
        var list = [];

        for (var i = 0; i < systems.length; i++) {

            var item = systems[i];

            var index = $.inArray(item, lines);

            if (index > -1) {
                list.push(self.linechartcolorlist[i]);
            } else {
                list.push("white");
            }
        }

        return list;

    }

    LineChartFormatterCommon.prototype.getLegendColors = function(systems, lines) {
        var self = this;
        var list = [];

        for (var i = 0; i < systems.length; i++) {

            var item = systems[i];

            var index = $.inArray(item, lines);

            if (index > -1) {
                list.push(self.linechartcolorlist[i]);
            } else {
                list.push("white");
            }
        }

        return list;

    };

    LineChartFormatterCommon.prototype.getLines = function(systems, options) {
        var list = [];

        if (options.filter.length == 0)
            return systems;

        for (var i = 0; i < systems.length; i++) {

            var item = systems[i];

            var index = $.inArray(item, options.filter);

            if (index > -1) {
                list.push(item);
            }
        }

        if (list.length == 0)
            return systems;
        else
            return list;
    };


    LineChartFormatterCommon.prototype.getFilterMaster = function(systems, options) {
        var list = [];

        if (!options.filterMaster || options.filterMaster.length == 0)
            return systems;

        for (var i = 0; i < systems.length; i++) {

            var item = systems[i];

            var index = $.inArray(item, options.filterMaster);

            if (index > -1) {
                list.push(item);
            }
        }

        if (list.length == 0)
            return systems;
        else
            return list;
    };

    LineChartFormatterCommon.prototype.dispose = function () { };

    export default LineChartFormatterCommon;

